<div class="p-0">
  <div class="clear-both">
  </div>
  <!-- Old table wrapper class kept for reference:
  <div class="table-responsive">
  -->
  <div class="dashboard-table-wrap w-full max-w-full overflow-x-auto rounded-xl border border-slate-200 bg-white pt-0">
    <!-- Old table class kept for reference: tableStyleClass="table  width-full" -->
    <p-table #d1 [value]="data" [alwaysShowPaginator]="false" [lazy]="tableConfig?.isLazy || false"
      [paginator]="!tableConfig?.noPagination" (onLazyLoad)="loadData($event)" [rows]="defaultRow" [autoLayout]="true"
      [totalRecords]="totalRecords" [globalFilterFields]="cols" [resizableColumns]="true" [first]="first"
      columnResizeMode="expand" [globalFilterFields]="globalFilterField" [responsive]="true"
      styleClass="w-full min-w-0" tableStyleClass="min-w-[720px] lg:min-w-full w-full mb-0 border-separate border-spacing-0 text-slate-800 dashboard-table" [virtualScroll]="tableConfig?.virtualScroll || false"
      [scrollable]="tableConfig?.virtualScroll || false" [columns]="cols"
      [scrollHeight]="tableConfig?.scrollHeightPx ? ((data?.length *(tableConfig?.scrollHeightPx || 0)) > 1000 ? '1000px' : ((data?.length || 1) + 1) * (tableConfig?.scrollHeightPx || 100)+'px') :undefined"
      [virtualScrollItemSize]="tableConfig?.virtualScrollItemSize || 0">
      <ng-template pTemplate="caption">
        <div class="flex flex-row justify-end">
          @if (tableConfig?.globalFilter) {
          <div class="p-2">
            <input class="table-search-input" placeholder="Search.." pInputText type="text"
              (input)="d1.filterGlobal($any($event.target).value, 'contains')">
          </div>
          }
        </div>
      </ng-template>
      <ng-template *ngIf="mode=='TABLE'" pTemplate="header">
        <tr class="bg-neutral-100 text-slate-500 shadow-none">
          @if (selectable) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3">Select</th>
          }
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3">S/No.</th>
          @for (col of cols; track col; let i = $index) {
          @if (col.sort) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
          } @else {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3"> {{col.header}}</th>
          }
          }
          @if (actionBtn?.length) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3">Actions
            <button type="button" (click)="reload()" class="table-icon-btn table-icon-btn-light ml-1" title="Reload Table"
              [disabled]="tableLoader">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin pi-spinner': tableLoader}"></i></button>
            @if (tableConfig?.addBtn) {
            <button type="button" (click)="btnAction('','ADD')" class="table-icon-btn table-icon-btn-primary ml-1" title="Add New"
              [disabled]="tableLoader">
              <i class="pi pi-plus" [ngClass]="{'pi-spin pi-spinner': tableLoader}"></i></button>
            }
            @if (tableConfig?.exportBtn) {
            <button type="button" (click)="btnAction('','EXPORT')" class="table-icon-btn table-icon-btn-success ml-1" title="Export"
              [disabled]="exportLoading || tableLoader">
              <i class="pi pi-file-excel" [ngClass]="{'pi-spin pi-spinner': exportLoading || tableLoader}"></i></button>
            }
            @for (b of tableConfig?.headerAction || []; track b) {
            <button type="button" (click)="btnAction('', b.type, selectedData)" class="table-icon-btn ml-1 {{b.class || 'table-icon-btn-primary'}}"
              [title]="b?.title | titlecase" [disabled]="tableLoader">
              <i class="{{b.iconClass || 'text-default'}} {{b.icon}}"></i></button>
            }
          </th>
          }
        </tr>
        @if (tableConfig?.showFilter) {
        <tr class="bg-neutral-100 text-slate-500 shadow-none">
          @if (selectable) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3"></th>
          }
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3"></th>
          @for (c of cols; track c) {
          @if (c?.filter === true) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3">
            @if (c?.filterCol?.type == 'TEXT' || !c?.filterCol?.type) {
            <p-columnFilter type="text" placeholder="search" matchMode="contains" [showMenu]="false"
              [field]="c?.field"></p-columnFilter>
            }
            @if (c?.filterCol?.type == 'DROPDOWN') {
            <p-columnFilter [field]="c?.colName" matchMode="equals" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" [appendTo]="'body'" styleClass="dashboard-filter-dropdown"
                  panelStyleClass="dashboard-filter-dropdown-panel" [style]="{'width':'100%' ,'padding' : '0'}"
                  [filter]="FORM_SUPPORT_DATA[c?.colName]?.length > 15 ? true : false" (onChange)="filter($event.value)"
                  [options]="FORM_SUPPORT_DATA[c?.colName]" [optionValue]="c?.filterCol?.selectPrimaryKey ||  'key'"
                  [placeholder]="c?.filterCol?.placeholder || 'Any'"
                  [optionLabel]="c?.filterCol?.selectKeyName || 'label'" [showClear]="true">
                  <ng-template let-option pTemplate="item">
                    @if (DATA_LOADING[c?.colName]) {
                    <span class="customer-badge status">{{ 'loading...' }}</span>
                    }
                    <span class="customer-badge status">{{option[c?.filterCol?.selectKeyName
                      || 'label']}}</span>
                  </ng-template>
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
            }
            @if (c?.filterCol?.type == 'DATE') {
            <p-columnFilter [field]="c?.field" matchMode="equals" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-calendar [readonlyInput]="true" dateFormat="dd/mm/yy" [showButtonBar]="true" [showClear]="true"
                  appendTo="body" styleClass="dashboard-filter-calendar"
                  panelStyleClass="dashboard-filter-calendar-panel" [view]="c?.filterCol?.dateViewMode || 'date'" (onSelect)="filter($event)"
                  (onClear)="filter(null)" (onClearClick)="filter(null)" [maxDate]="c?.filterCol?.maxDate"
                  [monthNavigator]="c?.filterCol?.monthNavigator ?true : false"
                  [yearNavigator]="c?.filterCol?.yearNavigator ? true : false" [minDate]="c?.filterCol?.minDate"
                  [yearRange]="c?.filterCol?.yearRange || yearRange" [placeholder]="c?.filterCol?.placeholder || 'Any'">
                </p-calendar>
              </ng-template>
            </p-columnFilter>
            }
          </th>
          } @else {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3"></th>
          }
          } @if (actionBtn?.length) {
          <th class="whitespace-nowrap border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-xs font-bold uppercase text-slate-500 md:px-4 md:py-3"></th>
          }
        </tr>
        }
        @if (tableLoader) {
        <tr class="tableloader">
          <td [attr.colspan]="(cols.length+1) + (actionBtn?.length || 0) + (selectable ? 1 : 0)" class="border-0 border-b border-solid border-slate-200 px-3 py-2 text-center align-middle text-sm font-medium leading-snug text-slate-500 md:px-4 md:py-3"><i
              class="pi pi-spin pi-spinner"></i>Please
            wait data fetching...</td>
        </tr>
        }
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="tableloader">
          <td [attr.colspan]="(cols.length+1) + (actionBtn?.length || 0) + (selectable ? 1 : 0)" class="border-0 border-b border-solid border-slate-200 px-3 py-2 text-center align-middle text-sm font-medium leading-snug text-slate-500 md:px-4 md:py-3" *ngIf="showNoData">No data
            found.</td>
        </tr>
      </ng-template>
      <ng-template *ngIf="mode=='TABLE'" pTemplate="body" let-request let-i="rowIndex">
        <tr class="bg-white transition-colors duration-150 odd:bg-white even:bg-slate-50 hover:cursor-pointer hover:bg-blue-50 focus:bg-blue-50" (click)="onSelectData(request)"
          [ngClass]="request.classList || ''">
          @if (selectable) {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm font-medium leading-snug text-slate-800 md:px-4 md:py-3">
            <input type="checkbox" [checked]="request.selectable"
              (click)="$event.stopPropagation()" (change)="onSelectData(request)">
          </td>
          }
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm font-medium leading-snug text-slate-800 md:px-4 md:py-3">{{i + 1}}</td>
          @for (col of cols; track col; let i = $index) {
          @if (!col?.isEditable) {
          @switch (col?.type) {
          @case ('IMAGE') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            <img imageLoad [src]="request[col.field]" alt="Document" class="h-9 w-9 rounded border border-solid border-slate-200 object-cover">
          </td>
          }
          <!-- <td colspan="" *ngSwitchCase="'NAME_WITH_IMG'">
                                  <span>
                                    <img imageLoad [src]="request[col.field]" alt="Document"
                                      class="w35 h35 rounded">
                                    </span>
                                    <span>
                                      <span *ngIf="col?.icon_append?.text && request[col.field] ; else noAppend"
                                      [innerHTML]="request[col.field] + ' ' +col?.icon_append?.text || '' | safeHtml"></span>
                                      <ng-template #noAppend><span
                                      [innerHTML]="request[col.field] || '' | safeHtml"></span></ng-template>
                                      <ng-container
                                        *ngFor="let f of request[col.field] | transformArray:',':' & '">
                                        <strong><a title="Staff Info" (click)="openStaffInfo(f)"
                                        href="javascript:void(0)">{{f}}</a></strong>
                                      </ng-container>
                                    </span>
                                  </td> -->
          @case ('DATE') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            {{request[col.field] | dateFormat:'dd-MM-yyyy'}}</td>
          }
          @case ('DATETIME') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            {{request[col.field] | dateFormat:'dd-MM-yyyy h:mm a'}}</td>
          }
          @case ('CURRENCY') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">{{request[col.field] | currencyFormat}}</td>
          }
          @case ('STATUS') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            <span class="badge"
              [ngClass]="{'badge-success' : +request[col.field]==1 , 'badge-danger' : +request[col.field] ==0, 'badge-warning' : +request[col.field] == 2 }">{{statusArray[request[col.field]]}}</span>
          </td>
          }
          @case ('DROPDOWN') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            @for (m of FORM_SUPPORT_DATA[col?.colName]; track m) {
            @if (m[col?.filterCol?.selectPrimaryKey || 'key'] == request[col.colName]) {
            @if (m?.color ) {
            <span class="badge badge-{{m?.color || 'info'}}">{{
              m[col?.filterCol?.selectKeyName || 'label']}}</span>
            }@else{
            {{ m[col?.filterCol?.selectKeyName || 'label']}}
            }
            }
            }
          </td>
          }
          @case ('STAFF_EMP_ID') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            @for (f of request[col.field] | transformArray:',':' & '; track f) {
            <strong><a title="Staff Info" (click)="openStaffInfo(f)" href="javascript:void(0)">{{f}}</a></strong>
            }
          </td>
          }
          @case ('VIEW_INFO') {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            <strong>
              <a title="Patient Info" (click)="openPatientInfo(request.id)" href="javascript:void(0)">
                {{request.patient_id}}
              </a>
            </strong>
          </td>
          }
          <!-- @case ('VIEW_INFO') {
          <td>
            @for (f of request[col.field] | transformArray:',':' & '; track f) {
            <strong><a title="View Info" (click)="btnAnchorAction(f,request)" href="javascript:void(0)"
                [innerHTML]="f |safeHtml"></a></strong>
            }
          </td>
          } -->
          @case ('VIEW_TAG_INFO') {
          <td style="white-space: normal; min-width: 100px;max-width:30vw;" class="cursor-pointer border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            @for (f of request[col.field]; track f) {
            <span (click)="btnTagInfo(f,request)" [innerHTML]="f?.text |safeHtml"></span>
            }
          </td>
          }
          @default {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            @if (col?.icon_append?.text && request[col.field] ) {
            <span [innerHTML]="request[col.field] + ' ' +col?.icon_append?.text || '' | safeHtml"></span>
            } @else {
            <span [innerHTML]="request[col.field] || '' | safeHtml"></span>
            }
            <ng-template #noAppend><span [innerHTML]="request[col.field] || '' | safeHtml"></span></ng-template>
          </td>
          }
          }
          } @else {
          <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800" pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" (keydown.enter)="updateRow(request,col?.field,request[col.field])"
              (change)="updateRow(request,col?.field,request[col.field])" class="w-full"
                  [(ngModel)]="request[col.field]" required>
              </ng-template>
              <ng-template pTemplate="output">
                <span>{{request[col.field]}}</span>
              </ng-template>
            </p-cellEditor>
          </td>
          }
          <ng-template #isEditable>
            <td class="border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800" pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" (keydown.enter)="updateRow(request,col?.field,request[col.field])"
                    (change)="updateRow(request,col?.field,request[col.field])" class="w-full"
                    [(ngModel)]="request[col.field]" required>
                </ng-template>
                <ng-template pTemplate="output">
                  <span>{{request[col.field]}}</span>
                </ng-template>
              </p-cellEditor>
            </td>
          </ng-template>
          }
          @if (actionBtn?.length && makeChange) {
          <td class="action-buttons border-0 border-b border-solid border-slate-200 px-3 py-2 align-middle text-sm md:px-4 md:py-3 font-medium leading-snug text-slate-800">
            @for (b of actionBtn; track b) {
            @switch (b?.category) {
            @case ('TEXT') {
            @if (!b.condition || (b.condition && (request | conditionOperator : b.condition))) {
            <span>{{b.name}}</span>
            }
            }
            @default {
            @if (!b.condition || (b.condition && (request | conditionOperator : b.condition))) {
            <button class="table-action-btn ml-1 {{b.class || ''}}" [class.btn-default]="!b.class"
              [title]="b?.title | titlecase"
              (click)="$event.stopPropagation();btnAction(request[primaryKey] || '', b?.type,request,i)"><i
                class="{{b.iconClass || 'text-default'}} {{b.icon}}"></i></button>
            }
            }
            }
            }
          </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
        <span class="font-semibold text-slate-500">
          Total Request {{ state.first ? state.first + 1 : 1 }} -
          {{ (state.first + state.rows) > state.totalRecords ?
          state.totalRecords : state.rows + state.first }}
          of {{ state.totalRecords }}
        </span>
      </ng-template>

    </p-table>
  </div>
</div>
